import { render, staticRenderFns } from "./CompanyTariffs.vue?vue&type=template&id=3bba4eaf&scoped=true&"
import script from "./CompanyTariffs.vue?vue&type=script&lang=js&"
export * from "./CompanyTariffs.vue?vue&type=script&lang=js&"
import style0 from "./CompanyTariffs.vue?vue&type=style&index=0&id=3bba4eaf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bba4eaf",
  null
  
)

export default component.exports